import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';
import { queryOptions } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export default function useFarms(props) {
    const { state: userData } = useContext(LoginContext);

    const {
        data: farms,
        isLoading: farmsLoading,
        error: farmsError,
        refetch: refetchFarms
    } = useProtectedQuery({
        queryKey: ['get_farms',],
        queryFn: async () => {
            let url = '/api/accounts/get-farms';


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting farms");
            }

        },
    });




    return {
        farms,
        farmsLoading,
        farmsError,
        refetchFarms,

        // stratAcctFarms


    }
}
